import { FunctionComponent, useState } from 'react';
import {
    Card,
    CardContent,
    InputAdornment,
    SvgIcon,
    FilledInput,
    InputLabel,
    FormControl,
    Box,
    Button,
    Chip,
} from '@mui/material';
import MagnifyingGlassIcon from '@heroicons/react/24/solid/MagnifyingGlassIcon';
import { Checkbox } from '@/components/Checkbox/Checkbox';

type ChipFilterName =
    'smartpricer' | 'incert' | 'dynamicPricing' | 'faceValidation';

const chipFilters: { name: ChipFilterName; label: string }[] = [
    { name: 'smartpricer', label: 'Smartpricer' },
    { name: 'incert', label: 'Incert' },
    { name: 'dynamicPricing', label: 'Dynamic Pricing' },
    { name: 'faceValidation', label: 'Gesichtserkennung' },
];

type LiftOperatorSearchProps = {
    onSearchChange: (searchTerm: string) => void;
    onShowInActiveChange: (inactive: boolean) => void;
    onDownloadAsCsv: () => void;
    onChipClick: (chipName: ChipFilterName) => void;
};

export const LiftOperatorSearch: FunctionComponent<LiftOperatorSearchProps> = ({
    onShowInActiveChange,
    onSearchChange,
    onDownloadAsCsv,
    onChipClick,
}) => {
    const [activeChip, setActiveChip] = useState<ChipFilterName[]>([]);

    const handleChipClick = (chipName: ChipFilterName) => {
        setActiveChip((prev) =>
            prev.includes(chipName)
                ? prev.filter((name) => name !== chipName)
                : [...prev, chipName]
        );
        onChipClick(chipName);
    };

    return (
        <Card
            sx={{
                width: '100%',
            }}
        >
            <CardContent>
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        py: 1,
                        mb: 2,
                    }}
                >
                    <Checkbox
                        label='Inaktive einblenden'
                        onChange={(_event, checked) => {
                            onShowInActiveChange(checked);
                        }}
                    />

                    <Button
                        sx={{
                            marginLeft: 'auto',
                        }}
                        variant='outlined'
                        color='primary'
                        onClick={onDownloadAsCsv}
                    >
                        CSV herunterladen
                    </Button>
                </Box>

                <FormControl variant='filled' fullWidth>
                    <InputLabel>Bergbahnen durchsuchen</InputLabel>
                    <FilledInput
                        onChange={(e) => {
                            const { value } = e.target;
                            onSearchChange(value);
                        }}
                        startAdornment={
                            <InputAdornment position='start'>
                                <SvgIcon>
                                    <MagnifyingGlassIcon />
                                </SvgIcon>
                            </InputAdornment>
                        }
                        fullWidth
                    />
                </FormControl>

                <Box
                    sx={{
                        display: 'flex',
                        gap: 2,
                        py: 1,
                        mt: 2,
                    }}
                >
                    {chipFilters.map((chip) => (
                        <Chip
                            key={chip.name}
                            color='primary'
                            label={chip.label}
                            onClick={() => handleChipClick(chip.name)}
                            variant={
                                activeChip.includes(chip.name)
                                    ? 'filled'
                                    : 'outlined'
                            }
                            clickable
                        />
                    ))}
                </Box>
            </CardContent>
        </Card>
    );
};
